"use client";

import { useIsMobile } from "@/hooks/useIsMobile";
import { PropsWithChildren } from "react";
interface Props {
  isMobile: boolean;
}
const MobileOrPcOnly: React.FC<PropsWithChildren<Props>> = ({
  children,
  isMobile,
}) => {
  const mobile = useIsMobile();
  return <>{mobile ? (isMobile ? children : null) : children}</>;
};

export default MobileOrPcOnly;
